import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TelemetryEventName } from '@app/@shared/enums';
import { ProductOverviewElement } from '@app/@shared/models/navigation/navigation.models';
import { AssetInfo } from '@app/@shared/models/pdf-asset-info';
import { TelemetryEvent } from '@app/@shared/models/telemetry-event';
import { MarketAnalysisService } from '@app/@shared/services/market-analysis/market-analysis.service';
import { MetaService } from '@app/@shared/services/meta.service';
import { NavigationService } from '@app/@shared/services/navigation/navigation.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { of } from 'rxjs';
import { concatMap } from 'rxjs/operators';

@Component({
    selector: 'app-product-overview',
    templateUrl: './product-overview.component.html',
    styleUrls: ['./product-overview.component.scss'],
    standalone: false
})
@UntilDestroy()
export class ProductOverviewComponent implements OnInit {
  public pdfAssetInfo: AssetInfo;
  public subscriptionName = '';
  public showErrorMessage = false;
  public subscriptionId = '';
  public productOverview: ProductOverviewElement;
  public isProductOverview: boolean;
  private module: string;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly marketAnalysisService: MarketAnalysisService,
    private readonly metaService: MetaService,
    private readonly navigationService: NavigationService
  ) {}

  public ngOnInit(): void {
    this.route.paramMap.pipe(
      concatMap((params) => {
        this.subscriptionId = params.get('subscriptionId');
        this.module = this.route.snapshot.data.module
        return this.navigationService.getSubscription(this.subscriptionId, this.module)
      }),
      concatMap((subscription) => {
        this.subscriptionName = subscription.name;
        this.productOverview = subscription.productOverview;
        this.isProductOverview = this.productOverview?.assetId !== undefined &&
          this.productOverview?.reportCode !== undefined;
        if (this.isProductOverview) {
          return of({url: undefined})
        } else {
          this.postEventForSubscriptionOverview();
          return this.marketAnalysisService.getSubscriptionBriefXodUrl(
            subscription.briefingFilename
          );
        }
      }),
      untilDestroyed(this)
    ).subscribe((response) => {
      if (this.isProductOverview) {
        const fragment = new URLSearchParams();
        fragment.set('moduleName', this.module);
        fragment.set('reportCode', this.productOverview.reportCode);
        fragment.set('subscriptionId', this.subscriptionId);
        this.router.navigate(['hg-asset', this.productOverview.assetId], {
          fragment: fragment.toString(),
          skipLocationChange: true
        });
      } else if (response.url) {
        this.pdfAssetInfo = { url: response.url, signedUrl: response.url, clObjectId: null};
      } else {
        this.showErrorMessage = true;
      }
    }, () => {
      this.showErrorMessage = true;
    });
  }

  private postEventForSubscriptionOverview(): void{
    // Create parameters for view Product overview pdf events
    const payload = {
      reportTitle: `Product Overview - ${this.subscriptionName}`,
      artifactName: 'Product_Overview.pdf',
      artifactType: 'application/pdf',
      downloadSizeBytes: 0,
      subscriptionId: this.subscriptionId,
    };
    const applicationModule = this.module;
    const event = new TelemetryEvent(TelemetryEventName.EVENT_VIEW_IN_BROWSER, payload, applicationModule);
    this.metaService.postTelemetryEvent(event).subscribe();
  }

}

